import { render, staticRenderFns } from "./ExpenseDefaultPricingTable.vue?vue&type=template&id=8471a140&scoped=true&"
import script from "./ExpenseDefaultPricingTable.vue?vue&type=script&lang=js&"
export * from "./ExpenseDefaultPricingTable.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseDefaultPricingTable.vue?vue&type=style&index=0&id=8471a140&lang=scss&scoped=true&"
import style1 from "./ExpenseDefaultPricingTable.vue?vue&type=style&index=1&lang=css&"
import style2 from "./ExpenseDefaultPricingTable.vue?vue&type=style&index=2&id=8471a140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8471a140",
  null
  
)

export default component.exports